import { useEffect } from 'react';
import { STATISTICS_SECTION_ID } from '../../components/StatisticsSection/StatisticsSection';

export const useRedirectToProfilePage = ({ ready, redirectToProfilePage }) => {
    useEffect(() => {
        if (!ready) return;

        const timerId = setTimeout(() => {
            redirectToProfilePage({}, `#${STATISTICS_SECTION_ID}`);
        }, 1500);

        return () => clearTimeout(timerId);
    }, [ready]);
};
